import { Box, Drawer as MuiDrawer, Button } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const DRAWER_WIDTH = 576

export const Drawer = styled(MuiDrawer)`
  .MuiPaper-root {
    background: ${theme.colors.surfaceContainerBackground};
    box-shadow: ${theme.attributes.boxShadow.selectFieldPaper};
    width: ${DRAWER_WIDTH}px;
    overflow-x: hidden;

    ::-webkit-scrollbar {
      width: 4px;
      background: transparent;
    }

    ::-webkit-scrollbar-track {
      box-shadow: none;
      background: ${theme.colors.strokePrimary};
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.cta};
      border-radius: ${theme.attributes.borderRadius.quaternary};
    }
  }
`

export const DrawerContent = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const DrawerHeader = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 40px 40px 0 40px;
  gap: 16px;

  .drawer-title {
    color: ${theme.colors.menuItemText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 28px;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 42px;
  }

  .close-button {
    padding: 6px;
    min-width: unset;

    &:hover {
      background: rgba(202, 196, 208, 0.12);
    }

    svg path {
      stroke: ${theme.colors.menuItemText};
    }
  }
`

export const DrawerBody = styled(Box)`
  flex: 1;
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.borderMedium};
    border-radius: ${theme.attributes.borderRadius.quaternary};
  }
`

export const FormField = styled(Box)`
  position: relative;

  .MuiOutlinedInput-root {
    border-radius: ${theme.attributes.borderRadius.tertiary};
    background: transparent;
    height: 48px;

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.colors.cta};
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.colors.cta};
      border-width: 1px;
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.colors.dropdownBorder};
    }

    .MuiOutlinedInput-input {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 14px;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
      padding: 14px 16px;
    }
  }

  .MuiSelect-icon {
    color: ${theme.colors.devicesSecondaryText};
    right: 16px;

    &.MuiSelect-iconOpen {
      color: ${theme.colors.cta};
    }
  }

  .MuiInputLabel-root {
    color: ${theme.colors.dropdownLabel};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 12px;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 12px;
    transform: translate(14px, -9px) scale(1);
    background: ${theme.colors.surfaceContainerBackground};
    padding: 0 4px;

    &.Mui-focused {
      color: ${theme.colors.dropdownLabel};
    }
  }
`

export const DrawerFooter = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 32px 40px;
  background: ${theme.colors.surfaceContainerBackground};
`

export const CancelButton = styled(Button)`
  flex: 1;
  height: 48px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.dropdownBorder};
  background: transparent;
  text-transform: none;

  &:hover {
    background: rgba(78, 68, 75, 0.3);
    border-color: ${theme.colors.dropdownBorder};
  }

  .button-text {
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 22px;
  }
`

export const SaveButton = styled(Button)`
  flex: 1;
  height: 48px;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  background-color: ${theme.colors.cta} !important;
  text-transform: none;

  &:hover {
    background-color: #c477c1 !important;
  }

  &.Mui-disabled {
    background-color: #946592 !important;

    .button-text {
      color: ${theme.colors.surfaceContainerBackground};
    }
  }

  html[data-theme='light'] & {
    &:hover {
      background-color: ${theme.colors.buttonHollowHover} !important;
    }

    &.Mui-disabled {
      background-color: ${theme.colors.cardFillTertiary} !important;
      opacity: 1;

      .button-text {
        color: ${theme.colors.btnSecondaryDisabledText};
      }
    }
  }

  .button-text {
    color: ${theme.colors.surfaceContainerBackground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 22px;
  }
`
